export default __webpack_public_path__ + "static/google_cloud-4896ef5708c5ffd83e70ffc6bfadbe19.svg";